export default __webpack_public_path__ + "static/media/hallsofeternalfrostnormal.c99bc98c.jpg";